// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import ProfileImage from 'shared/components/ProfileImage';
import GroupStatusIndicator from '../GroupStatusIndicator';
import { ProviderMappingResult, ReferralProfile } from '../types'; // eslint-disable-line no-unused-vars
import classes from './ProviderInfoCard.module.scss';

/** @typedef {{
  matchingResult: ProviderMappingResult,
  referralProfile: ReferralProfile
}} ProviderInfoCardPropsType */

/** @type { React.ValidationMap<ProviderInfoCardPropsType> } */
const propTypes = {
  matchingResult: PropTypes.object.isRequired,
  referralProfile: PropTypes.object.isRequired,
};

/** @type { StatelessComponent<ProviderInfoCardPropsType> } */
const ProviderInfoCard = ({ matchingResult, referralProfile }) => {
  const {
    provider,
    earliestAppointmentTime,
    earliestAppointmentTimeInWords,
    acceptingNewPatients,
  } = matchingResult;
  const hasTime = !!earliestAppointmentTime;

  return (
    <div className={classes.ProviderInfoCard}>
      {acceptingNewPatients || (
        <div className={classes.not_accepting}>Not Accepting New Patients</div>
      )}
      <div className={classes.header}>
        <div className={classes.heading}>{provider.nameWithAppellation}</div>
        <div className={classes.sub_heading}>{provider.specialtyNames.join(', ')}</div>
      </div>

      <div className={classes.midsection}>
        {hasTime && (
          <div>
            <div className={classes.stat}>{earliestAppointmentTimeInWords}</div>
            <div className={classes.label}>Soonest Availability</div>
          </div>
        )}
      </div>

      {/* Below the others so it appears on top of the previous 2 sections */}
      <div className={classes.provider_image_container}>
        <ProfileImage src={provider.profileImagePath} size={95} />
      </div>

      <div className={classes.footer}>
        <GroupStatusIndicator
          enteredByGuest={!!referralProfile.enteredByGuest}
          enteredByReceiver={!!referralProfile.enteredByReceiver}
          isVhan={!!referralProfile.isVhan}
          hasGroup={referralProfile.hasGroup}
          isInGroup={provider.isInGroup}
        />
        {/* TODO: #1741 Display insurance acceptance information. https://github.com/Preferral/Preferral/issues/1741 */}
        {/* TODO: CSS for this spot probably needs to be tweaked to make them side-by-side */}
        {/* <p className="quick-qualifier">Ins. Accepted</p> */}
      </div>
    </div>
  );
};

ProviderInfoCard.displayName = 'ProviderInfoCard';
ProviderInfoCard.propTypes = propTypes;

export default ProviderInfoCard;
